"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var types_1 = require("../client/types");

var exceptions_1 = require("../exceptions");

var chrome_tcp_utils_1 = require("./chrome-tcp-utils");

var noop = function noop() {
  var _ = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    _[_i] = arguments[_i];
  }

  return void 0;
};

var Socket =
/** @class */
function () {
  function Socket(autoResume) {
    if (autoResume === void 0) {
      autoResume = false;
    }

    this.autoResume = autoResume;
    this.closed = true;
    this.closeListeners = [];
    this.dataListeners = [];
    this.errorListeners = [];
  }

  Socket.prototype.create = function () {
    return __awaiter(this, void 0, void 0, function () {
      var socketId;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , chrome_tcp_utils_1.create()];

          case 1:
            socketId = _a.sent();
            this.socketId = socketId;
            this.closed = false;
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Socket.prototype.destroy = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.closed || !this.socketId) return [2
            /*return*/
            ];
            return [4
            /*yield*/
            , chrome_tcp_utils_1.close(this.socketId)];

          case 1:
            _a.sent();

            this.invokeListeners(this.closeListeners, undefined);
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Socket.prototype.connect = function (port, host, onConnect) {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.socketId) {
              throw new exceptions_1.SocketError('Invalid socket instance');
            }

            chrome.sockets.tcp.onReceive.addListener(function (eventInfo) {
              if (eventInfo.socketId === _this.socketId) {
                var data = Buffer.from(eventInfo.data);

                _this.onData(data);
              }
            });
            chrome.sockets.tcp.onReceiveError.addListener(function (eventInfo) {
              if (eventInfo.socketId === _this.socketId) {
                var error = chrome_tcp_utils_1.messageForResultCode(eventInfo.resultCode);

                _this.onError(new exceptions_1.SocketError(error));

                if (_this.autoResume) {
                  chrome.sockets.tcp.setPaused(_this.socketId, false);
                }
              }
            });
            return [4
            /*yield*/
            , chrome_tcp_utils_1.connect(this.socketId, port, host)];

          case 1:
            _a.sent();

            if (typeof onConnect === 'function') onConnect();
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Socket.prototype.off = function (eventType, callback) {
    switch (eventType) {
      case types_1.EventType.DATA:
        this.dataListeners = this.dataListeners.filter(function (fn) {
          return fn !== callback;
        });
        break;

      case types_1.EventType.ERROR:
        this.errorListeners = this.errorListeners.filter(function (fn) {
          return fn !== callback;
        });
        break;

      case types_1.EventType.CLOSE:
        this.closeListeners = this.closeListeners.filter(function (fn) {
          return fn !== callback;
        });
        break;

      default:
        return noop(callback);
    }
  };

  Socket.prototype.on = function (eventType, callback) {
    switch (eventType) {
      case types_1.EventType.DATA:
        this.dataListeners = this.dataListeners.concat(callback);
        break;

      case types_1.EventType.ERROR:
        this.errorListeners = this.errorListeners.concat(callback);
        break;

      case types_1.EventType.CLOSE:
        this.closeListeners = this.closeListeners.concat(callback);
        break;

      default:
        return noop(callback);
    }
  };

  Socket.prototype.write = function (message) {
    if (!this.socketId) throw new exceptions_1.SocketError('Socket initialization failed.');
    if (this.closed) throw new exceptions_1.SocketError('Socket is closed.');
    var arrayBuffer = message.buffer;
    return chrome_tcp_utils_1.write(this.socketId, arrayBuffer);
  };

  Socket.prototype.onData = function (data) {
    this.invokeListeners(this.dataListeners, data);
  };

  Socket.prototype.onError = function (error) {
    this.invokeListeners(this.errorListeners, error);
  };

  Socket.prototype.invokeListeners = function (listenerAry, data) {
    listenerAry.forEach(function (listener) {
      return listener(data);
    });
  };

  return Socket;
}();

exports.default = Socket;